export const percentageFormat = (value: number, maxdecimals: number): string => {
  return new Intl.NumberFormat("nl-NL", {
    style: "decimal",
    maximumFractionDigits: maxdecimals
  }).format(value);
};
